import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { style: {"padding":"20px"} }

import { withDefaults, reactive, ref } from 'vue';
import {
  BaseDialog,
  BaseForm,
  BaseFormItem,
  BaseFormRef,
  BaseInput,
  BaseButton,
  BaseRadio,
  BaseRadioGroup,
  BaseAutocomplete,
  BaseDatePicker
} from 'xrk-components';
import { preProcurementTaskQuantity } from '../data-source/apis';
import { userTags } from '@/views/project-task/src/data-source/apis';

export default /*#__PURE__*/_defineComponent({
  __name: 'project-person-add-alone',
  props: {
    remove: { type: Function, default() {
      return () => ({});
    } },
    projectId: { default: null },
    isSceneType19: { type: Boolean }
  },
  emits: ['success'],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emits = __emit;
const formRef = ref<BaseFormRef>(null);
const formData = reactive<{
  name: string;
  phone: number;
  procurementTaskQuantity: number;
  userTag: string;
  prePurchaseAt: string;
  importMethod: number;
}>({
  name: '',
  phone: null,
  procurementTaskQuantity: null,
  userTag: '',
  prePurchaseAt: '',
  importMethod: null
});
const disabledDate = time => {
  const cur = new Date();
  const curDate = cur.getDate() - 1;
  cur.setDate(curDate);
  return time.getTime() < cur.getTime();
};
const onSave = async () => {
  await formRef.value.validate();
  await preProcurementTaskQuantity({
    projectId: props.projectId,
    name: formData.name,
    phone: formData.phone,
    procurementTaskQuantity: formData.procurementTaskQuantity,
    userTag: formData.userTag,
    prePurchaseAt: formData.prePurchaseAt,
    importMethod: formData.importMethod
  });
  emits('success');
  onCancel();
};
const onCancel = () => {
  props.remove();
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(BaseDialog), {
    width: "450px",
    visible: true,
    "model-value": true,
    "show-close": true,
    "close-on-press-escape": true,
    "close-on-click-modal": false,
    title: "单独添加预采购任务量"
  }, {
    footer: _withCtx(() => [
      _createVNode(_unref(BaseButton), {
        onClick: onCancel,
        type: "default"
      }, {
        default: _withCtx(() => [
          _createTextVNode("取消")
        ]),
        _: 1
      }),
      _createVNode(_unref(BaseButton), {
        click: onSave,
        type: "primary"
      }, {
        default: _withCtx(() => [
          _createTextVNode("确定")
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_unref(BaseForm), {
          ref_key: "formRef",
          ref: formRef,
          model: formData,
          "label-width": "auto",
          "label-position": "right"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(BaseFormItem), {
              label: "姓名：",
              prop: "name",
              rules: [{ required: true, message: '姓名必填' }]
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(BaseInput), {
                  style: {"width":"100%"},
                  placeholder: "请输入姓名",
                  modelValue: formData.name,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.name) = $event)),
                  maxlength: "30"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_unref(BaseFormItem), {
              label: "手机号：",
              prop: "phone",
              rules: [{ required: true, message: '手机号必填' }]
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(BaseInput), {
                  style: {"width":"100%"},
                  placeholder: "请输入手机号",
                  modelValue: formData.phone,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.phone) = $event)),
                  type: "tel",
                  maxlength: "11"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            (!_ctx.isSceneType19)
              ? (_openBlock(), _createBlock(_unref(BaseFormItem), {
                  key: 0,
                  label: "预采购任务量：",
                  prop: "procurementTaskQuantity",
                  rules: [{ required: true, message: '预采购任务量必填' }]
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(BaseInput), {
                      style: {"width":"100%"},
                      placeholder: "请输入预采购任务量",
                      modelValue: formData.procurementTaskQuantity,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.procurementTaskQuantity) = $event)),
                      inputTextReplace: true,
                      maxlength: "6",
                      inputTexts: ['数字']
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_unref(BaseFormItem), {
              label: "人员标签：",
              prop: "userTag"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(BaseAutocomplete), {
                  style: {"width":"100%"},
                  placeholder: "请输入人员标签",
                  modelValue: formData.userTag,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.userTag) = $event)),
                  "fetch-suggestions": 
              async (queryString, cb) => {
                const { data } = await _unref(userTags)({
                  projectId: _ctx.projectId
                });
                const list = data.map(item => {
                  return { value: item.label, label: item.label };
                });
                if (list.length === 1 && list[0].value === '未设置') {
                  return cb([]);
                }
                return cb(
                  list.filter(
                    i => !queryString || i.value?.indexOf(queryString) > -1
                  )
                );
              }
            
                }, null, 8, ["modelValue", "fetch-suggestions"])
              ]),
              _: 1
            }),
            _createVNode(_unref(BaseFormItem), {
              rules: [
            { required: true, message: '请选择日期', trigger: 'change' }
          ],
              label: "预采购时间：",
              prop: "prePurchaseAt"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(BaseDatePicker), {
                  style: {"width":"100%"},
                  disabledDate: disabledDate,
                  modelValue: formData.prePurchaseAt,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formData.prePurchaseAt) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_unref(BaseFormItem), {
              rules: [{ required: true, message: '请选择导入方式' }],
              label: "导入方式：",
              prop: "importMethod"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", null, [
                  _createVNode(_unref(BaseRadioGroup), {
                    modelValue: formData.importMethod,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formData.importMethod) = $event))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(BaseRadio), { value: 1 }, {
                        default: _withCtx(() => [
                          _createTextVNode("覆盖原数据")
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(BaseRadio), { value: 2 }, {
                        default: _withCtx(() => [
                          _createTextVNode("累加原数据")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ])
    ]),
    _: 1
  }))
}
}

})